export const EASYDESK_SET_USER = 'EASYDESK_SET_USER';
export const EASYDESK_RESET = 'EASYDESK_RESET';

export const ANALYTICS_IDENTITY = 'ANALYTICS_IDENTITY';
export const ANALYTICS_RESET = 'ANALYTICS_RESET';
